import {
  Button,
  Card,
  Descriptions,
  Form,
  Input,
  Modal,
  Notification,
  Select,
  Typography,
} from '@arco-design/web-react';
import { useEffect, useState } from 'react';
import { GetPrototypeItem } from '../../service/prototype/type';
import {
  Alibaba_Product_Status,
  Category,
  finishPublish,
  getCategories,
  getPrototypeById,
} from '../../service/prototype';
import { ArrowDownOutlined, LoadingOutlined } from '@ant-design/icons';
import { getThumbnail } from '../../common/components/UploadToCOS/util';
import { PageHeader } from '../components/Layout';

const ImageWithDownload = ({
  src,
  filename,
  tagText,
  isVideo,
}: {
  src?: string;
  tagText?: string;
  isVideo?: boolean;
  filename: string;
}) => {
  const [loading, setLoading] = useState<boolean>();
  const [videoThumbNailUrl, setVideoThumbNailUrl] = useState<string>();
  useEffect(() => {
    if (isVideo) {
      setLoading(true);
      getThumbnail({
        url: src,
        fileType: 'video',
        width: 84,
        height: 84,
      })
        .then((url) => {
          setLoading(false);
          setVideoThumbNailUrl(url);
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
        });
    }
  }, [src, isVideo]);

  const imageSrc = isVideo ? videoThumbNailUrl : src;

  return src ? (
    <div
      style={{
        cursor: 'pointer',
        border: '1px solid rgb(196, 198, 207)',
        borderRadius: 4,
        overflow: 'hidden',
        position: 'relative',
        width: 'fit-content',
      }}
    >
      <div
        style={{
          width: 84,
          height: 84,
        }}
      >
        {imageSrc ? (
          <img
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
            src={imageSrc}
            alt="thumbnail"
          ></img>
        ) : null}
      </div>
      <div
        style={{
          position: 'absolute',
          cursor: 'pointer',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 16,
          height: 16,
          fontSize: 10,
          background: 'rgba(0,0,0,0.6)',
          color: '#fff',
          borderRadius: '50%',
          border: 'none',
          textAlign: 'center',
        }}
        onClick={() => {
          const link = document.createElement('a');
          link.setAttribute('download', filename);
          link.href = src;
          document.body.appendChild(link);
          link.click();
          link.remove();
        }}
      >
        {loading ? <LoadingOutlined /> : <ArrowDownOutlined />}
      </div>
      {tagText ? (
        <div
          style={{
            position: 'absolute',
            backgroundColor: '#7467e9',
            top: 0,
            left: 0,
            padding: '3px 4px',
            borderRadius: '2px 0px 4px 0px',
            color: '#fff',
            fontSize: 12,
            lineHeight: '18px',
          }}
        >
          <span style={{ fontSize: 12, fontWeight: 400 }}>{tagText}</span>
        </div>
      ) : null}
    </div>
  ) : null;
};

export const Title = ({
  text,
  marginBottom = 16,
}: {
  text: string;
  marginBottom?: number;
}) => (
  <Typography.Title style={{ fontSize: 14, marginBottom, marginTop: 0 }}>
    {text}
  </Typography.Title>
);

const SubTitle = ({ text }: { text: string }) => (
  <div
    style={{
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '18px',
      marginBottom: 8,
      color: '#000',
    }}
  >
    {text}
  </div>
);

export const Publish = () => {
  const pathName = window.location.pathname;
  const protoTypeId = pathName.split('/')[2];
  const [prototype, setPrototype] = useState<GetPrototypeItem>();
  const [categories, setCategories] = useState<Category[]>();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [form] = Form.useForm();

  const category = categories?.find((cat) => cat.code === prototype?.category);

  useEffect(() => {
    getPrototypeById({
      prototype_id: protoTypeId,
    })
      .then(({ prototype }) => {
        setPrototype(prototype);
      })
      .catch((e) => {
        console.error(e);
        Notification.error({
          content: '获取样品信息失败',
        });
      });
    getCategories()
      .then(({ categories }) => {
        setCategories(categories);
      })
      .catch((e) => {
        console.error(e);
        Notification.error({
          content: '获取品类信息失败',
        });
      });
  }, [protoTypeId]);

  const isPageShown = prototype && categories;
  const fabricObj = prototype?.fabric_json
    ? JSON.parse(prototype?.fabric_json)
    : {};
  const fillingObj = prototype?.filling_json
    ? JSON.parse(prototype?.filling_json)
    : {};
  const productScaleObj = prototype?.product_scale_json
    ? JSON.parse(prototype?.product_scale_json)
    : {};
  const packageScaleObj = prototype?.package_scale_json
    ? JSON.parse(prototype?.package_scale_json)
    : {};

  const handleSubmit = async (values: {
    alibaba_product_id: string;
    alibaba_product_status: Alibaba_Product_Status;
  }) => {
    try {
      setSubmitLoading(true);
      await finishPublish({ ...values, prototype_id: protoTypeId });
      setIsVisible(false);
      Notification.success({
        content: '感谢用心上架每一款产品，辛苦了！',
      });
    } catch (e) {
      Notification.error({
        content: '发布商品失败',
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <div
      style={{
        background: '#f3f3f3',
        padding: 40,
        minHeight: '100vh',
        boxSizing: 'border-box',
      }}
    >
      <PageHeader text="依凡诗纺织科技-商品发布" />
      {isPageShown ? (
        <>
          <Card title="基本信息" style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: 20 }}>
              <Title text="商品图片&视频" />
              <div
                style={{
                  padding: 20,
                  background: 'rgb(252, 252, 252)',
                  borderRadius: 4,
                  border: '1px solid #d9d9d9',
                  width: '100%',
                  display: 'flex',
                  gap: 16,
                  boxSizing: 'border-box',
                }}
              >
                <ImageWithDownload
                  src={prototype?.main_image_cos_urls?.[0]}
                  filename="主图"
                  tagText="主图"
                />
                <ImageWithDownload
                  src={prototype?.scene_image_cos_urls?.[0]}
                  filename="场景图"
                />
                <ImageWithDownload
                  src={prototype?.detail_image_cos_urls?.[0]}
                  filename="细节图"
                />
                <ImageWithDownload
                  src={prototype?.size_image_cos_urls?.[0]}
                  filename="尺寸图"
                />
                <ImageWithDownload
                  src={prototype?.other_image_cos_urls?.[0]}
                  filename="其他图"
                />
                <ImageWithDownload
                  src={prototype?.video_cos_urls?.[0]}
                  filename="主图视频"
                  isVideo={true}
                  tagText="主图视频"
                />
              </div>
            </div>
            <div style={{ marginBottom: 20 }}>
              <Title text="商品名称" />
              <Typography.Paragraph copyable>
                {prototype?.prototype_name}
              </Typography.Paragraph>
            </div>
            <div style={{ marginBottom: 20 }}>
              <Title text="商品分组" />
              <Typography.Paragraph copyable={true}>
                {category?.name_en}
              </Typography.Paragraph>
            </div>
            <div style={{ marginBottom: 20 }}>
              <Title text="商品属性" />
              <Descriptions
                data={[
                  {
                    label: '封面材质',
                    value: fabricObj.fabric_name_en,
                  },
                  {
                    label: '产品特性',
                    value: prototype.features.join(', '),
                  },
                  {
                    label: '填充料',
                    value: fillingObj.filling_name_en,
                  },
                  {
                    label: '重量',
                    value: fillingObj.filling_weight,
                  },
                  {
                    label: '产地',
                    value: 'China',
                  },
                  {
                    label: 'logo/图文定制工艺',
                    value: 'Embroidery',
                  },
                  {
                    label: '品牌名称',
                    value: 'S&I Textiles',
                  },
                  {
                    label: '部件',
                    value: ['Neck', 'Body'].join(', '),
                  },
                  {
                    label: '是否可定制',
                    value: 'Yes',
                  },
                  {
                    label: '面料支数',
                    value: fabricObj.specs?.split('/')?.[0]?.trim(),
                  },
                  {
                    label: '织物经纬密度',
                    value: fabricObj.specs?.split('/')?.[1]?.trim(),
                  },
                  {
                    label: '风格',
                    value: prototype.style,
                  },
                  {
                    label: '保养说明',
                    value: prototype.wash_instructions.join(', '),
                  },
                ]}
                layout="inline-vertical"
                border
                column={3}
              />
            </div>
          </Card>
          <Card title="交易信息" style={{ marginBottom: 20 }}>
            <div>
              <Title text="商品规格" />
              <Descriptions
                layout="inline-vertical"
                data={[
                  {
                    label: '颜色',
                    value: productScaleObj?.colors,
                  },
                  {
                    label: '尺寸',
                    value: (
                      <div>
                        {((productScaleObj?.sizes || []) as string[]).map(
                          (size) => (
                            <div key={size}>{size}</div>
                          )
                        )}
                      </div>
                    ),
                  },
                ]}
                border
                style={{ marginBottom: 20 }}
              />
              <Descriptions
                layout="inline-vertical"
                data={[
                  {
                    label: '基础销售方式',
                    value: '按件卖',
                  },
                  {
                    label: '计量单位',
                    value: 'Piece/Pieces',
                  },
                ]}
                border
                style={{ marginBottom: 20 }}
              />
              <Descriptions
                layout="vertical"
                column={2}
                data={[
                  {
                    label: '最小起订量 (件)',
                    value: '> = 5',
                  },
                  {
                    label: '单件价格 (计量单位)',
                    value: prototype.standard_usd_price,
                  },
                  {
                    label: '最小起订量 (件)',
                    value: '> = 100',
                  },
                  {
                    label: '单件价格 (计量单位)',
                    value: prototype.standard_usd_price * 0.9,
                  },
                  {
                    label: '最小起订量 (件)',
                    value: '> = 1000',
                  },
                  {
                    label: '单件价格 (计量单位)',
                    value: prototype.standard_usd_price * 0.7,
                  },
                ]}
                border
                style={{ marginBottom: 20 }}
              />
              <Title text="发货期" />
              <Descriptions
                layout="vertical"
                column={2}
                data={[
                  {
                    label: '数量 (计量单位)',
                    value: '<= 5',
                  },
                  {
                    label: '预计时间 (天)',
                    value: '10 天',
                  },
                  {
                    label: '数量 (计量单位)',
                    value: '<= 100',
                  },
                  {
                    label: '预计时间 (天)',
                    value: '14 天',
                  },
                  {
                    label: '数量 (计量单位)',
                    value: '<= 1000',
                  },
                  {
                    label: '预计时间 (天)',
                    value: '30 天',
                  },
                ]}
                border
              />
            </div>
          </Card>
          <Card title="物流信息" style={{ marginBottom: 20 }}>
            <Title text="体积与重量(含物流包装)" />
            <Descriptions
              border
              column={6}
              data={[
                {
                  label: '毛重(KG)',
                  value: packageScaleObj.standard_weight_kg,
                },
                {
                  label: '长(CM)',
                  value: packageScaleObj.standard_length_cm,
                },
                {
                  label: '宽(CM)',
                  value: packageScaleObj.standard_width_cm,
                },
                {
                  label: '高(CM)',
                  value: packageScaleObj.standard_height_cm,
                },
                {
                  label: '物流属性',
                  value: '普货',
                },
                {
                  label: '箱规',
                  value: '智能托管',
                },
              ]}
              layout="vertical"
            />
          </Card>
          <Card title="商品详情信息" style={{ marginBottom: 20 }}>
            <Title text="1. 商品介绍" />
            <div
              style={{
                background: '#fcfcfc',
                padding: 20,
                border: '1px solid rgb(238, 238, 238)',
                borderRadius: 4,
                marginBottom: 20,
              }}
            >
              <div style={{ marginBottom: 20 }}>
                <SubTitle text="详情图片" />
                <div
                  style={{ display: 'flex', gap: 16, boxSizing: 'border-box' }}
                >
                  <ImageWithDownload
                    src={prototype?.size_image_cos_urls?.[0]}
                    filename="尺寸图"
                    tagText="尺寸图"
                  />
                  <ImageWithDownload
                    src={prototype?.scene_image_cos_urls?.[0]}
                    filename="场景图"
                    tagText="场景图"
                  />
                  <ImageWithDownload
                    src={prototype?.detail_image_cos_urls?.[0]}
                    filename="细节图"
                    tagText="细节图"
                  />
                  <ImageWithDownload
                    src={prototype?.other_image_cos_urls?.[0]}
                    filename="其他商品图片"
                    tagText="其他商品图片"
                  />
                  <ImageWithDownload
                    src={prototype?.other_image_cos_urls?.[0]}
                    filename="其他商品图片"
                    tagText="其他商品图片"
                  />
                </div>
              </div>
              <div style={{ marginBottom: 20 }}>
                <SubTitle text="商品卖点" />
                <div>一键生成</div>
              </div>
              <div>
                <SubTitle text="详情视频" />
                <ImageWithDownload
                  src={prototype?.video_cos_urls?.[0]}
                  isVideo={true}
                  filename="详情视频"
                  tagText="详情视频"
                />
              </div>
            </div>
            <Title text="2. 公司介绍" />
            <div
              style={{
                background: '#fcfcfc',
                padding: 20,
                border: '1px solid rgb(238, 238, 238)',
                borderRadius: 4,
              }}
            >
              使用公司模板
            </div>
          </Card>
          <Button
            type="primary"
            onClick={() => setIsVisible(true)}
            style={{ width: 120, height: 40, margin: 'auto', display: 'block' }}
          >
            完成
          </Button>
        </>
      ) : null}
      <Modal
        visible={isVisible}
        onCancel={() => setIsVisible(false)}
        onConfirm={() => form.submit()}
        okButtonProps={{
          loading: submitLoading,
        }}
        title="完成商品发布"
      >
        <Form form={form} onSubmit={handleSubmit}>
          <Form.Item
            label="商品 ID"
            field="alibaba_product_id"
            rules={[{ required: true, message: '请填写阿里巴巴商品 ID' }]}
          >
            <Input placeholder="请填写阿里巴巴商品 ID" />
          </Form.Item>
          <Form.Item
            label="状态"
            field="alibaba_product_status"
            rules={[{ required: true, message: '请选择阿里巴巴商品状态' }]}
          >
            <Select
              options={[
                {
                  label: '草稿',
                  value: 'draft',
                },
                {
                  label: '上架',
                  value: 'on_the_shelf',
                },
                {
                  label: '下架',
                  value: 'off_the_shelf',
                },
              ]}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
